import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';
import {strCode} from '../../consts/strCode';
import useAiAssistantWidget from '../../hooks/useAiAssistantWidget';
import aiAssistantAccessService from '../../services/aiAssistant/aiAssistantAccessService';
import featuresService from '../../services/features/featuresService';
import {t} from '../../services/localization/localizationService';
import {CrossFade} from '../CrossFade/CrossFade';
import AiAssistantCloseIcon from '../Icons/AiAssistantIcons/AiAssistantCloseIcon';
import AiAssistantIcon from '../Icons/AiAssistantIcons/AiAssistantIcon';
import NavigationBarTab from '../NavigationBar/NavigationBarTab';

const CROSS_FADE_HIDDEN_SCALED = {opacity: 0, scale: 0.5};
const CROSS_FADE_VISIBLE_SCALED = {opacity: 1, scale: 1};

const AiAssistantButton = ({className}) => {
    const {isWidgetOpened, closeWidget} = useAiAssistantWidget();
    const isFeatureEnabled = featuresService.getIsFeatureEnabled(IAP_FEATURES_CODES.AI_ASSISTANT);

    const onClick = () => (isWidgetOpened ? closeWidget() : aiAssistantAccessService.openAiAssistant());

    if (!isFeatureEnabled) return null;

    const activeKey = isWidgetOpened ? 'close' : 'ask';

    return (
        <NavigationBarTab
            onClick={onClick}
            rumActionName={awsRumActionNames.AI_ASSISTANT}
            className={className}
            icon={
                <CrossFade
                    activeKey={activeKey}
                    layerClassName='flex items-center justify-center'
                    hidden={CROSS_FADE_HIDDEN_SCALED}
                    visible={CROSS_FADE_VISIBLE_SCALED}
                    layers={{ask: <AiAssistantIcon />, close: <AiAssistantCloseIcon />}}
                />
            }
            label={
                <CrossFade
                    activeKey={activeKey}
                    layerClassName='flex items-center justify-center'
                    hidden={CROSS_FADE_HIDDEN_SCALED}
                    visible={CROSS_FADE_VISIBLE_SCALED}
                    layers={{ask: t(strCode.AI_ASSISTANT_ASK_BUTTON), close: t(strCode.AI_ASSISTANT_CLOSE_BUTTON)}}
                />
            }
        />
    );
};

export default AiAssistantButton;
